let instafeedLoaded = false;

function loadScript() {
  if (instafeedLoaded) return;

  instafeedLoaded = true;

  const script = document.createElement('script');

  script.src = 'https://cdn.nfcube.com/instafeed-4cda43b4b8aaf647a194b9f6d7f12199.js';
  script.async = true;

  script.onload = () => {
    console.log('Instafeed loaded');
  };

  script.onerror = () => {
    console.error('Failed to load Instafeed');
    instafeedLoaded = false; // 允许重新尝试
  };

  document.body.appendChild(script);
}

const target = document.querySelector('#insta-feed');

const observer = new IntersectionObserver((entries)=>{

    if(!entries[0].isIntersecting) return;

    observer.disconnect();

    loadScript();

},{
    rootMargin:'300px'
});

observer.observe(target);